const l = {
  name: "Cocktail",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M29,0H40v2h-9.7l-1.5,4H40L21,27.4V38h7v2H12v-2h7V27.4L0,6h26.7L29,0z M4.5,8l5.3,6h14L26,8H4.5z M11.6,16
			l8.1,9.1L23,16H11.6z M25.2,16l-2.4,6.4l5.7-6.4H25.2z M30.2,14l5.3-6h-7.5l-2.2,6H30.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Cocktail
};
